import { useRound } from '@/hooks/PlayerSessionControlHooks';
import { usePromptTextById } from '@/hooks/usePromptText';

/**
 * @param text Optional prompt text. When provided, no prompt is fetched. Used by demo
 * mode, which runs without any API access.
 */
export default function PlayerPrompt({ text }: { text?: string } = {}) {
  const round = useRound();
  // `usePromptTextById` skips its query when the id is falsy, so passing undefined
  // here keeps demo mode fully offline.
  const fetchedText = usePromptTextById(text ? undefined : round?.promptId);
  const promptText = text ?? fetchedText;

  return (
    <div className="relative text-center">
      <div className="h-96 sm:h-112 md:h-128 overflow-visible ">
        <svg
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="100%"
          preserveAspectRatio="none"
          viewBox="0 0 407 153"
        >
          <path
            d="M28.97,133.42l-16.95-26.87V.23h391.94v102.49l-15.46,25.72-66.82,24.57c-24.1-3.58-79.09-9.9-106.21-6.52-33.91,4.22-87.26-4.22-113.19-4.22-20.74,0-57.51-5.88-73.3-8.83Z"
            style={{ fill: '#99d9d9', strokeWidth: 0 }}
          />
          <path
            d="M85.73,0c-18.15,7.58-37.2,14.56-56.4,20.4C19.15,39.48,7.06,58.07,0,78.06c12.09,26.1,50.25,42.42,75.14,62.12,85.8-10.84,175.21-20.81,263.08-26.58,56.38-4.74,41.74,4.5,68.79-34.09-5.86-15.15-19.27-48.26-28.54-62.86-36.86-4.57-76.14-5.25-113.74-9.08-60.47-4.7-120.16,3.83-178.99-7.57Z"
            style={{ fill: '#77baba', strokeWidth: 0 }}
          />
          <path
            d="M316.85,133.81c16.85-6.89,34.55-13.24,52.38-18.55,9.45-17.34,20.68-34.24,27.23-52.42-11.23-23.73-46.66-38.56-69.77-56.47-79.68,9.85-162.71,18.92-244.3,24.17-52.35,4.31-38.76-4.09-63.88,30.99,5.44,13.77,17.9,43.87,26.51,57.14,34.23,4.15,70.71,4.78,105.62,8.26,56.16,4.27,111.58-3.48,166.21,6.88Z"
            style={{ fill: '#fff', strokeWidth: 0 }}
          />
        </svg>
      </div>
      <div className="absolute top-1/2 left-1/2 w-[85%] max-w-3xl transform -translate-x-1/2 -translate-y-1/2 text-[#d51668] font-bold text-center">
        <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl transition-all duration-300 ease-in-out">
          {promptText}
        </p>
      </div>
    </div>
  );
}
